import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { message } from 'antd'
import type { SuburbConfig } from 'config/constants/types'
import { useActiveEvent } from 'state/events/hooks'
import type { PropertyState, PropertyData } from '../types'
import { getCouncilListingEdit, updateListing } from './helpers'

// interface SetListingEditPayload {
//   listing: CouncilsListingEdit[]
// }

// interface SetSuburbEditPayload {
//   suburb: SuburbConfig
// }

const initialState: PropertyState = {
  isInitialized: false,
  isLoading: true,
  data: null,
}

enum STATUS {
  READY,
  PRE_VALIDATED,
  PRE_VALIDATION_ERROR,
  VALIDATING,
  VALIDATION_ERROR_COLUMN,
  VALIDATION_ERROR_DATA,
  IN_PROGRESS,
  ERROR,
}

export const listingSlice = createSlice({
  name: 'property',
  initialState,
  reducers: {
    fetchListing: (state) => {
      state.isLoading = true
      // state.hasError = false
    },
    setListing: (state, action: PayloadAction<PropertyData>) => {
      state.data = action.payload
      state.isLoading = false
      state.isInitialized = true
      // state.hasError = false
    },
    fetchListingFailed: (state) => {
      state.data = null
      state.isInitialized = false
      state.isLoading = false
      //  state.hasError = true
    },
  },
})

export const fetchCouncilListingEdit = (_id: string) => async (dispatch) => {
  try {
    dispatch(fetchListing())
    const listingData = await getCouncilListingEdit(_id)
    dispatch(setListing(listingData))
  } catch (error) {
    message.error('Error gettings stats')
    dispatch(fetchListingFailed())
  }
}

export const updateCouncilListing = (data: string) => async (dispatch) => {
  //   console.log('data')
  //   console.log(data)
  try {
    const result = await updateListing(data)
    // console.log('result')
    // console.log(result)
    // setCsvData([])w
    if (result.status === 'failed') {
      // setValidationErrors(result.errors)
      message.error('Update Failed')
      // dispatch(fetchListingFailed())
      if (result.message === 'columnsMissing') {
        //     setStatus(STATUS.VALIDATION_ERROR_COLUMN)
        message.error('Column missing')
        // dispatch(fetchListingFailed())
      } else {
        //      setStatus(STATUS.VALIDATION_ERROR_DATA)
        message.error('Data Error')
        // dispatch(fetchListingFailed())
      }
    } else {
      //    setStatus(STATUS.IN_PROGRESS)
      message.success('Property has been updated')
      // dispatch(setListing({data}))
    }
  } catch (error: any) {
    // console.error(error)
    message.error(error)
  }
}

// Actions
export const { fetchListing, setListing, fetchListingFailed } = listingSlice.actions

export default listingSlice.reducer
